import { render, staticRenderFns } from "./dbTask.vue?vue&type=template&id=41eb167c&"
import script from "./dbTask.vue?vue&type=script&lang=js&"
export * from "./dbTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports